module.exports = __webpack_public_path__ + "img/Illustration.06709017.svg";